export default [
  [1, 0.94],
  [2, 1.4],
  [3, 2],
  [4, 2.5],
  [5, 3]
]
